import { defineMessages } from 'react-intl';

const messages = defineMessages({
  insurance: {
    id: 'App.InsuranceSetup.Insurance',
    defaultMessage: 'Insurance',
  },
  allowThirdPartyInsurancePolicies: {
    id: 'App.InsuranceSetup.AllowThirdPartyInsurancePolicies',
    defaultMessage: 'Allow 3rd Party Insurance Policies',
  },
  allowThirdPartyInsurancePoliciesTooltip: {
    id: 'App.InsuranceSetup.AllowThirdPartyInsurancePoliciesTooltip',
    defaultMessage:
      'Allows team members to add and manage third-party renters insurance policies on household profiles. ' +
      'When used with Asset Protect, households are only charged an Asset Protect fee if no' +
      ' active insurance policy is on file.',
  },
});

export default messages;
